import { useWebSocketStatus, WebSocketConnectionStatus } from "@/hooks/use-websocket-status"
import { cn } from "@/lib/utils"

interface WebSocketIndicatorProps {
  className?: string
  showText?: boolean
  size?: "sm" | "md" | "lg"
}

/**
 * Componente que exibe o status da conexão WebSocket
 *
 * @example
 * // Com texto
 * <WebSocketIndicator />
 *
 * // Apenas ícone
 * <WebSocketIndicator showText={false} size="sm" />
 */
export function WebSocketIndicator({ showText = true, size = "md" }: WebSocketIndicatorProps) {
  const { status } = useWebSocketStatus()

  // Mapeamento de status para cores e texto em português
  const statusConfig: Record<WebSocketConnectionStatus, { color: string; text: string }> = {
    connected: { color: "bg-green-500", text: "Online" },
    connecting: { color: "bg-amber-500", text: "Conectando" },
    disconnected: { color: "bg-red-500", text: "Offline" },
  }

  const config = statusConfig[status]

  // Tamanhos do indicador
  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  }

  return (
    <div className="flex items-center gap-2">
      <div
        className={cn("animate-pulse rounded-full", config.color, sizeClasses[size])}
        style={{ cursor: status === "disconnected" ? "pointer" : "default" }}
      />

      {showText && <span className="text-muted-foreground text-xs">{config.text}</span>}
    </div>
  )
}
